import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  open:         "bg-amber-50 text-amber-800 border-amber-200",
  in_progress:  "bg-blue-50 text-blue-800 border-blue-200",
  reviewed:     "bg-indigo-50 text-indigo-800 border-indigo-200",
  completed:    "bg-emerald-50 text-emerald-800 border-emerald-200",
  rejected:     "bg-rose-50 text-rose-800 border-rose-200",
  pending:      "bg-amber-50 text-amber-800 border-amber-200",
  processing:   "bg-blue-50 text-blue-800 border-blue-200",
  paid:         "bg-emerald-50 text-emerald-800 border-emerald-200",
  overdue:      "bg-rose-50 text-rose-800 border-rose-200",
  offset:       "bg-zinc-100 text-zinc-700 border-zinc-300",
};

const LABELS = {
  open: "Open",
  in_progress: "In Progress",
  reviewed: "Reviewed",
  completed: "Completed",
  rejected: "Rejected",
  pending: "Pending",
  processing: "Processing",
  paid: "Paid",
  overdue: "Overdue",
  offset: "Offset",
};

export function StatusBadge({ status, className = "", labelOverride, ...rest }) {
  const key = (status || "").toLowerCase();
  const styles = STATUS_STYLES[key] || "bg-zinc-50 text-zinc-800 border-zinc-200";
  const label = labelOverride || LABELS[key] || status || "—";
  return (
    <Badge
      variant="outline"
      className={`font-medium border ${styles} ${className}`}
      data-testid={`status-badge-${key}`}
      {...rest}
    >
      {label}
    </Badge>
  );
}
